'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _phaser = require('phaser');

var _phaser2 = _interopRequireDefault(_phaser);

var _config = require('../config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _class = function (_Phaser$Sprite) {
  _inherits(_class, _Phaser$Sprite);

  function _class(_ref) {
    var game = _ref.game,
        x = _ref.x,
        y = _ref.y,
        asset = _ref.asset;

    _classCallCheck(this, _class);

    var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, game, x, y, asset));

    game.physics.arcade.enable(_this);
    _this.anchor.setTo(0.5);
    _this.jumps = 0.0;
    _this.body.collideWorldBounds = true;
    _this.body.gravity.y = _config2.default.world.gravity;
    var framenames = _phaser2.default.Animation.generateFrameNames('run/', 0, 7);
    _this.animations.add('run', framenames, 10, true, false);
    framenames = _phaser2.default.Animation.generateFrameNames('idle/', 0, 11);
    _this.animations.add('idle', framenames, 10, true, false);
    framenames = ['jump/jump.png'];
    _this.animations.add('jump', framenames, 10, true, false);
    framenames = _phaser2.default.Animation.generateFrameNames('freefall/', 0, 1);
    var anim = _this.animations.add('freefall', framenames, 5, true, false);
    _this.anchor.setTo(0.5, 0.5);
    _this.jumping = false;
    _this.game.scaleModel = _phaser2.default.ScaleManager.SHOW_ALL;
    _this.scale.setTo(_config2.default.player.scale);
    _this.targetAngle = 0.0;
    return _this;
  }

  _createClass(_class, [{
    key: 'update',
    value: function update() {
      if (this.body.blocked.down || this.underwater) {
        var vx = this.body.velocity.x;
        if (vx < -1.0 || vx > 1.0) {
          this.walkAnimation();
        } else {
          this.stopAnimation();
        }
      } else {
        if (this.jumping) {
          this.jumpAnimation();
        } else {
          this.freefallAnimation();
        }
      }

      var targetAngle = this.angle;
      var dt = this.game.time.physicsElapsed;
      var drag = 0.05;
      if (this.underwater) {
        this.body.gravity.y = -_config2.default.world.gravity / 2.0;
        var drag = 7.0;
      } else {
        this.body.gravity.y = _config2.default.world.gravity;
      }
      this.body.velocity.y = this.body.velocity.y - this.body.velocity.y * dt * drag;
      this.body.velocity.x = this.body.velocity.x - this.body.velocity.x * dt * drag;
      var diff = targetAngle - this.angle;
      if (diff > -10.0 && diff < 10.0) {
        this.angle = targetAngle;
      } else {
        this.angle += diff * dt * 3;
      }

      if ((this.body.blocked.down || this.underwater) && this.jumping) {
        this.jumping = false;
        this.jumps = 0.0;
      }
      if (this.falling && this.body.blocked.down) {
        this.sfx.jump.play(null, .1, 0.5, false, false);
        this.falling = false;
      }
      if (this.body.blocked.down == false && this.body.velocity.y > 100.0) this.falling = true;
    }
  }, {
    key: 'moveLeft',
    value: function moveLeft() {
      var dt = this.game.time.physicsElapsed;
      var accel = _config2.default.player.groundAccel;
      if (!this.body.blocked.down) accel = _config2.default.player.airAccel;
      var vx = this.body.velocity.x - accel * dt;
      if (vx < -_config2.default.player.targetSpeed) {
        vx = -_config2.default.player.targetSpeed;
      } else if (vx > -_config2.default.player.initialSpeed) {
        vx = -_config2.default.player.initialSpeed;
      }
      this.body.velocity.x = vx;
      this.scale.x = -_config2.default.player.scale;
    }
  }, {
    key: 'moveRight',
    value: function moveRight() {
      var dt = this.game.time.physicsElapsed;
      var accel = _config2.default.player.groundAccel;
      if (!this.body.blocked.down) accel = _config2.default.player.airAccel;
      var vx = this.body.velocity.x + accel * dt;
      if (vx > _config2.default.player.targetSpeed) {
        vx = _config2.default.player.targetSpeed;
      } else if (vx < _config2.default.player.initialSpeed) {
        vx = _config2.default.player.initialSpeed;
      }
      this.body.velocity.x = vx;
      this.scale.x = _config2.default.player.scale;
    }
  }, {
    key: 'startJump',
    value: function startJump() {
      if ((this.body.blocked.down || this.underwater) && this.jumping == false) {
        if (!this.underwater) this.sfx.jump.play(null, .1, 0.5, false, false);
        this.jumps = _config2.default.player.jumpBurst;
        this.body.velocity.y = -_config2.default.player.jumpBurst;
        this.jumping = true;
        this.body.blocked.down = false;
      }
    }
  }, {
    key: 'continueJump',
    value: function continueJump() {
      if (this.jumping && this.jumps < _config2.default.player.targetJumpSpeed) {
        var dt = this.game.time.physicsElapsed;
        var dv = dt * _config2.default.player.jumpAccel;
        this.body.velocity.y -= dv;
        this.jumps += dv;
      }
    }
  }, {
    key: 'stop',
    value: function stop() {
      var dt = this.game.time.physicsElapsed;
      var vx = this.body.velocity.x;
      if (vx < 0) {
        vx += _config2.default.player.groundDeaccel * dt;
        if (vx > 0) vx = 0;
      } else if (vx > 0) {
        vx -= _config2.default.player.groundDeaccel * dt;
        if (vx < 0) vx = 0;
      }
      if (vx < _config2.default.player.initialSpeed && vx > -_config2.default.player.initialSpeed) {
        vx = 0;
      }
      this.body.velocity.x = vx;
    }
  }, {
    key: 'walkAnimation',
    value: function walkAnimation() {
      this.animations.play('run');
    }
  }, {
    key: 'stopAnimation',
    value: function stopAnimation() {
      this.animations.play('idle');
    }
  }, {
    key: 'jumpAnimation',
    value: function jumpAnimation() {
      this.animations.play('jump');
    }
  }, {
    key: 'freefallAnimation',
    value: function freefallAnimation() {
      this.animations.play('freefall');
    }
  }]);

  return _class;
}(_phaser2.default.Sprite);

exports.default = _class;


//////////////////
// WEBPACK FOOTER
// ./src/sprites/Player.js
// module id = 126
// module chunks = 0